export function decodeImageURL(url?: string | null): string | undefined {
  if (!url) return url ?? undefined;
  // Some image URLs (e.g. project logos) are returned double URL-encoded by the
  // API, while others (e.g. delivery timeline images) are single-encoded.
  // A double-encoded URL contains "%25" (an encoded "%"); a single-encoded SAS
  // URL never does, since its decoded form is only base64 + ISO timestamps.
  // Decoding a single-encoded URL would turn "%2B" into "+", which Azure then
  // reads as a space and rejects the SAS signature. So only decode the
  // double-encoded case; leave correctly single-encoded URLs untouched.
  try {
    return /%25/i.test(url) ? decodeURIComponent(url) : url;
  } catch {
    return url;
  }
}
